import React, { Component } from 'react';
import groupBy from 'lodash/groupBy';
import PropTypes from 'prop-types';
import ClassicSideBar from './navigation/ClassicSidebarMenu';
import NextGenSideBar from './navigation/NextGenSidebarMenu';
import routeConfigLegacy from '../routeConfigLegacy';
import routeConfig from '../routeConfig';
import withRouter from './utilities/withRouter';

const propTypes = {
  routeConfig: PropTypes.shape({
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        authConfig: PropTypes.shape({
          requiredPermissions: PropTypes.arrayOf(PropTypes.string),
          anyOfPermissions: PropTypes.arrayOf(PropTypes.string),
        }),
      })
    ),
  }),
  nextGen: PropTypes.bool.isRequired,
  dynamicNavigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      group_name: PropTypes.string,
      order_in_group: PropTypes.number,
      hidden: PropTypes.bool,
      name: PropTypes.string,
      required_permissions: PropTypes.arrayOf(PropTypes.string),
      any_of_permissions: PropTypes.arrayOf(PropTypes.string),
      icon: PropTypes.string,
      url: PropTypes.string,
      external: PropTypes.bool,
      icon_set: PropTypes.string,
    })
  ),
};

// eslint-disable-next-line react/prefer-stateless-function
class DynamicSidebarMenu extends Component {
  render() {
    const { dynamicNavigationLinks } = this.props;
    // adding external navigation links to routeConfigs
    let dynamicLinks = { ...dynamicNavigationLinks };
    dynamicLinks = Object.fromEntries(Object.entries(dynamicLinks).filter(([, v]) => v != null));
    dynamicLinks = groupBy(dynamicLinks, 'group_name');
    Object.entries(dynamicLinks).forEach(([groupName, children]) => ({
      [groupName]: children.sort((a, b) => (a.order_in_group > b.order_in_group ? 1 : -1)),
    }));
    const prepareddynamicLinks = Object.entries(dynamicLinks).reduce((groupAgg, [groupName, childrenEntries]) => {
      const groupChildren = childrenEntries.reduce((agg, child) => {
        if (!child.hidden) {
          // Safely handle possibly missing or null permission arrays
          const requiredPermissions = Array.isArray(child.required_permissions) && child.required_permissions.length > 0
            ? child.required_permissions
            : undefined;

          const anyOfPermissions = Array.isArray(child.any_of_permissions) && child.any_of_permissions.length > 0
            ? child.any_of_permissions
            : undefined;

          agg.push({
            name: child.name,
            authConfig: {
              ...(requiredPermissions && { requiredPermissions }),
              ...(anyOfPermissions && { anyOfPermissions }),
            },
            component: () => {},
            icon: child.icon || '', // also safe-guard icon
            routeConfig: {
              exact: true,
              path: child.url,
              target: child.external ? '_blank' : '',
              isExternalNavigation: true,
            },
          });
        }
        return agg;
      }, []);
      // add not hidden children to group
      // Only add group if it has visible children
      if (groupChildren.length > 0) {
        const firstChild = childrenEntries[0];
        groupAgg.push({
          name: groupName,
          authConfig: {
            requiredPermissions: ['navigation_read'],
          },
          component: () => {},
          icon: firstChild?.icon_set || '', // safe access
          children: groupChildren,
        });
      }

      return groupAgg;
    }, []);

    const { nextGen } = this.props;

    if (nextGen) {
      const extendedRouteConfig = {
        groups: routeConfig.groups.concat(prepareddynamicLinks),
      };
      return <NextGenSideBar routeConfig={extendedRouteConfig} />;
    }
    const extendedRouteConfigLegacy = {
      groups: routeConfigLegacy.groups.concat(prepareddynamicLinks),
    };
    return <ClassicSideBar routeConfig={extendedRouteConfigLegacy} />;
  }
}

DynamicSidebarMenu.propTypes = propTypes;

export default withRouter(DynamicSidebarMenu);
